import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React from "react";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { ReactComponent as AlertIcon } from "Assets/Icons/Leaderboard/AlertIcon.svg";
import { TimelineDot } from "@mui/lab";

const GetTextHelp = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog fullWidth maxWidth={"xs"} open={open} onClose={handleClose}>
      <DialogTitle>
        Get help from teaching assistant
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent>
        <Box display={"flex"} justifyContent={"end"}>
          <Chip
            variant="outlined"
            color="success"
            outlined
            label={
              <Box display={"flex"} alignItems={"center"} gap="6px">
                {" "}
                <TimelineDot
                  sx={{
                    margin: "0px",
                    alignSelf: "center",
                    padding: "1px !important",
                  }}
                  color="success"
                />{" "}
                TAs are online{" "}
              </Box>
            }
          />
        </Box>
        <Typography mb="8px" color="secondary.light">
          Select one of the issues you are facing while solving the problem
        </Typography>
        <Select value={"1"} fullWidth size="small">
          <MenuItem disabled value="">
            <em>Select your issue</em>
          </MenuItem>
          <MenuItem value="1"> Facing Time Limit Exceeded (TLE) Error</MenuItem>
          <MenuItem value="2">Help clarify the problem statement</MenuItem>
          <MenuItem value="2">
            Help figure out solution approach to the problem
          </MenuItem>
          <MenuItem value="2">Facing Compilation Error</MenuItem>
          <MenuItem value="2">
            Facing Memory Limit Exceeded (MLE) Error
          </MenuItem>
          <MenuItem value="2">Facing Runtime Error</MenuItem>
          <MenuItem value="2">Help me Rectify the Syntax</MenuItem>
        </Select>
        <Typography
          display={"flex"}
          alignItems={"center"}
          gap="8px"
          mb="8px"
          mt="8px"
          color="secondary.light"
        >
          <PrimaryIcon icon={AlertIcon} width="16px" height="16px" />
          The system will share a snapshot of your code with the Teaching
          Assistant who claims your help request. Please avoid adding code in
          the issue
        </Typography>
        <FormControl fullWidth>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <FormLabel color="secondary" required label>
              Issue description
            </FormLabel>
            <Typography variant="body2" color="secondary.light">
              minimum 50 words
            </Typography>
          </Box>
          <Box></Box>
          <TextField
            size="small"
            placeholder="Please Provide a detailed explanation of your issue in a minimum of 50 words in here"
            multiline
            rows={3}
          />
        </FormControl>
      </DialogContent>
      <DialogActions align="end">
        <Button type="submit" variant="contained">
          Ask for help
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GetTextHelp;
